import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
	const { currentUser, isAdmin, loading } = useAuth();

	if (loading) {
		return (
			<div className="min-h-screen bg-gray-900 flex items-center justify-center">
				<div className="text-white text-xl">Loading...</div>
			</div>
		);
	}

	if (!currentUser) {
		return <Navigate to="/" replace />;
	}

	if (adminOnly && !isAdmin) {
		return <Navigate to="/dashboard" replace />;
	}

	return children;
};

export default ProtectedRoute;
